import script from "./newsView.vue?vue&type=script&setup=true&lang=js"
export * from "./newsView.vue?vue&type=script&setup=true&lang=js"

import "./newsView.vue?vue&type=style&index=0&id=504b3740&lang=scss&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-504b3740"]])

export default __exports__